import { useEffect, useState } from 'react';

import { gql, useQuery } from '@apollo/client';

export const GET_PUBLIC_EMPLOYEES_FOR_TABLE = gql`
  query getYuuHrMembers($filter: FilterMemberInput, $queryOptions: QueryOptionsInput) {
    getYuuHrMembers(filter: $filter, queryOptions: $queryOptions) {
      collection {
        _id
        createdBy
        profile {
          firstName
          lastName
        }
        account {
          accountFillStage
        }
        employeePersonalInfo {
          employeeNumber
          status
        }
        activeWorkingCondition {
          company {
            name
          }
          companyLocation {
            name
          }
          companyDepartment {
            name
            costCenter
          }
          job {
            title
          }
          jobSupervisor {
            supervisorJobTitle
            supervisorMember {
              profile {
                displayName
              }
            }
          }
        }
        createdAt
      }
      totalCount
    }
  }
`;

export const useGetEmployeesForTable = ({
  searchParam,
  filter,
}: {
  searchParam: string;
  filter: any;
}) => {
  const [currentPage, setPage] = useState(1);
  const [currentNameSort, setNameSort] = useState<{ field: string; sortBy: number }[]>();

  const pageSize = 12;
  const { data, loading } = useQuery(GET_PUBLIC_EMPLOYEES_FOR_TABLE, {
    variables: {
      queryOptions: {
        limit: pageSize,
        skip: pageSize * currentPage - pageSize,
        sort: currentNameSort,
      },
      filter: {
        companyId: filter.companyId,
        companiesFilter: filter.companyFilter,
        searchParam,
      },
    },
    skip: !filter.companyId,
    fetchPolicy: 'network-only',
  });

  const { totalCount = 0, collection = [] } = data?.getYuuHrMembers || {};

  useEffect(() => setPage(1), [searchParam]);

  return {
    loading,
    employees: collection,
    paginationConfig: {
      total: totalCount,
      pageSize,
      current: currentPage,
      onChange: (page: number) => setPage(page),
    },
    onTableChange: (a: any, b: any, order: any) => {
      if (order) {
        const sortBy = order === 'ascend' ? 1 : -1;

        setNameSort([{ field: 'name', sortBy }]);
      }
    },
  };
};
